import { FunctionComponent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './PreferencesSection.module.scss';

interface PreferencesSectionProps {
  children: ReactNode;
}

export const PreferencesSection: FunctionComponent<PreferencesSectionProps> = ({ children }) => {
  const { t: ctxT } = useTranslation('', { keyPrefix: 'pushNotifications' });

  return (
    <div className={classes['preferences-section']}>
      <div className={classes['preferences-section__columns']}>
        <span className={classes['preferences-section__columns-cell']}>{ctxT('column-push')}</span>
        <span className={classes['preferences-section__columns-cell']}>{ctxT('column-email')}</span>
      </div>
      <div className={classes['preferences-section__rows']}>{children}</div>
    </div>
  );
};
